import { serviceBillingModel } from '~/models';
import { PreapprovalPeriodType, RecurrencePeriodTypes } from '~/models/service-billing/model';
export const billingPeriodTextsPath = 'billing';
export function preapprovalPeriodWordMap(texts) {
    return {
        [PreapprovalPeriodType.None]: '',
        [PreapprovalPeriodType.NoTimeLimit]: '',
        [PreapprovalPeriodType.Weekly]: texts.week(),
        [PreapprovalPeriodType.BiWeekly]: texts.twoWeeks(),
        [PreapprovalPeriodType.Monthly]: texts.month(),
        [PreapprovalPeriodType.Quarterly]: texts.quarter(),
        [PreapprovalPeriodType.Yearly]: texts.year()
    };
}
export function recurrencePeriodWordMap(texts) {
    return {
        [RecurrencePeriodTypes.Weekly]: texts.week(),
        [RecurrencePeriodTypes.BiWeekly]: texts.twoWeeks(),
        [RecurrencePeriodTypes.Monthly]: texts.month(),
        [RecurrencePeriodTypes.Quarterly]: texts.quarter(),
        [RecurrencePeriodTypes.Yearly]: texts.year()
    };
}
export function preapprovalPeriodWord(period, texts) {
    return preapprovalPeriodWordMap(texts)[period];
}
export function recurrencePeriodWord(period, texts) {
    return recurrencePeriodWordMap(texts)[period];
}
export function extendedRecurrencePeriodWord(period, texts) {
    if (period === 'onetime' || period === 'inStages' || period === 'onDemand') return '';
    return recurrencePeriodWordMap(texts)[period];
}
export function recurrencePeriodSlashSuffix(period, texts) {
    const word = extendedRecurrencePeriodWord(period, texts);
    return word ? texts.slashSuffix({
        period: word
    }) : '';
}
function preapprovalPeriodVerbMap(texts) {
    return {
        [PreapprovalPeriodType.None]: texts.requires(),
        [PreapprovalPeriodType.NoTimeLimit]: texts.requires(),
        [PreapprovalPeriodType.Weekly]: texts.requires(),
        [PreapprovalPeriodType.BiWeekly]: texts.willRequire(),
        [PreapprovalPeriodType.Monthly]: texts.requires(),
        [PreapprovalPeriodType.Quarterly]: texts.requires(),
        [PreapprovalPeriodType.Yearly]: texts.requires()
    };
}
export function billingPeriodWord(billing, texts) {
    if (serviceBillingModel.isOnDemand(billing)) {
        return preapprovalPeriodWordMap(texts)[billing.preapprovalPeriod] || null;
    }
    if (serviceBillingModel.isRecurring(billing)) {
        return recurrencePeriodWordMap(texts)[billing.recurrencePeriod] || null;
    }
    return null;
}
export function billingPeriodSlashSuffix(billing, texts) {
    if (!billing) return '';
    const word = billingPeriodWord(billing, texts);
    return word ? texts.slashSuffix({
        period: word
    }) : '';
}
export function preapprovalPeriodVerb(period, texts) {
    return preapprovalPeriodVerbMap(texts)[period];
}
